import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Section } from '@feathr/components';
import Page from '@feathr/extender/App/Page';

import NativeIntegrations from './NativeIntegrations';
import ZapierIntegrationCards from './ZapierIntegrationCards';

import * as styles from './IntegrationsDashboardPage.css';

function IntegrationsDashboard(): JSX.Element {
  const { t } = useTranslation();

  return (
    <Page contentClassName={styles.content} title={t('Integrations')}>
      <Section
        className={styles.section}
        contentClassName={styles.grid}
        description={t('The local integration services within the Feathr app.')}
        layout={'vertical'}
        title={t('Feathr Integrations')}
      >
        <NativeIntegrations />
      </Section>
      <Section
        className={styles.section}
        contentClassName={styles.grid}
        description={t(
          'Feathr integrates with all these apps (and many others) via an integrations tool called Zapier. Click on the apps to visit their Zapier pages for more detail. You can also access help content through the links for each integration. Feathr seamlessly connects with these apps and many more through Zapier, a powerful integration platform. Explore the possibilities by clicking on each app to view its dedicated Zapier page. For additional guidance, simply follow the provided integration guides to get detailed information for each integration.',
        )}
        layout={'vertical'}
        title={t('Third-Party Integrations')}
      >
        <ZapierIntegrationCards />
      </Section>
    </Page>
  );
}

export default observer(IntegrationsDashboard);
